import { getGeo } from '@/pages-v2/home/storeList/component/StoreFilter/components/StoreCityFilter/utils'
import { defaultInteractionFilterValues } from './state'
import { cityValuesMap, requesterMap, exceptFilterKey } from './utils'
import { fetchBizoppTitle, fetchShopContactInfo } from '@/api'
import { getOperationData, getPriceData, getMarketPrice, getHistoryPrice } from './service'
async function requestListData(
  { commit, state, getters },
  { callback, pageSize = 20, reset = false },
) {
  if (state.searchNot) {
    return
  }
  commit('setLoading', true)
  const lists = state.lists || {}
  const currentTab = state.currentTab
  const currentListData = lists[currentTab] || {}
  const params = {
    pageNo: currentListData.pageNo || 1,
    pageSize: pageSize || currentListData.pageSize || 20,
  }
  const { data: ListData = [] } = currentListData
  if (reset) {
    params.pageNo = 1
    commit('updateListData', {
      currentTab,
      result: {
        ...params,
        total: 0,
        data: [],
      },
    })
  } else {
    params.pageNo += 1
  }
  const requester = requesterMap[currentTab]
  const citiesOptions = getters.citiesOptions || []
  const city = citiesOptions.find(item => item.value === getters.filterValues.cityId)
  const { countyIds = [] } = getters.filterValues
  if (!city) {
    callback && callback()
    commit('setLoading', false)
    return
  } else {
    // TODO: 城市特殊逻辑
    if (countyIds.length === 0) {
      const reduceChildren = (acc, cur) => {
        if (cur.children && cur.children.length > 0) {
          return acc.concat(cur.value, cur.children.reduce(reduceChildren, []))
        } else {
          return acc.concat(cur.value)
        }
      }
      const areaIds = city.children.reduce(reduceChildren, [])
      if (!areaIds.length) {
        callback && callback()
        commit('setLoading', false)
      }
      params.countyIds = areaIds || []
    }
  }
  const geo = await getGeo(reset)
  params.lat = geo.lat
  params.lng = geo.lng

  const wholeParams = { ...getters.filterValues, ...params }
  if (wholeParams.countyIds.length === 0) {
    callback && callback()
    commit('setLoading', false)
    return
  }
  requester(wholeParams)
    .then((data = {}) => {
      const { list = [], total } = data || {}
      const _list = list || []
      commit('updateListData', {
        currentTab,
        result: {
          ...params,
          total,
          data: reset ? _list : ListData.concat(_list),
        },
      })
      callback && callback()
      commit('setLoading', false)
    })
    .catch(() => {
      commit('setLoading', false)
      callback && callback()
    })
}

function updateCityAndAreaValue(
  { commit, state, getters },
  { cityId = '', countyIds = [], callback },
) {
  const currentTab = state.currentTab
  const keys = cityValuesMap[currentTab]
  if (keys && keys.length === 2) {
    const params = {
      [keys[0]]: cityId,
      [keys[1]]: countyIds,
    }
    commit('updateFilterValues', { ...params })
    updateAllTabBycityChange({ commit, state, getters })
  } else if (keys) {
    console.log('keys数组的长度不是2')
  } else {
    console.log('未找到当前城市的keys值')
  }
}
function updateAllTabBycityChange({ commit, state, getters }) {
  const { lists } = state
  for (const key in lists) {
    // eslint-disable-next-line no-prototype-builtins
    if (lists.hasOwnProperty(key)) {
      const data = lists[key].data
      if (Array.isArray(data)) {
        if (data.length !== 0) {
          commit('updateListData', {
            currentTab: key,
            result: {
              pageNo: 1,
              total: 0,
              data: [],
            },
          })
        }
      }
    }
  }
}
export default {
  // 更新当前Tab值
  updateCurrentTab({ commit, state, getters }, { currentTab }) {
    commit('updateSearchNot', false)
    commit('updateCurrentTab', currentTab)
    const lists = state.lists || {}
    const currentListData = lists[currentTab] || {}
    const { data = [] } = currentListData
    // 没有数据时请求
    if ((data || []).length === 0) {
      requestListData({ commit, state, getters }, { reset: true })
    }
  },
  // 更新筛选项值
  updateFilterValues({ commit, state, getters }, { callback, ...params }) {
    commit('updateSearchNot', false)
    const { cityId = '', countyIds = [], ...Lparams } = params
    // NOTES: 以防万一，对商圈城市和普通城市区别设置
    if (cityId) {
      updateCityAndAreaValue({ commit, state, getters }, { cityId, countyIds })
    }
    commit('updateFilterValues', { ...Lparams })
    requestListData({ commit, state, getters }, { callback, reset: true })
  },
  // 更新筛选项枚举
  updateFilterOptions({ commit, state }, params = {}) {
    commit('updateFilterOptions', params)
  },
  // 请求列表数据
  requestListData({ commit, state, getters }, { callback, pageSize, reset = false }) {
    commit('updateSearchNot', false)
    requestListData({ commit, state, getters }, { callback, pageSize, reset })
  },
  // 设置loading属性
  setLoading({ commit }, params) {
    commit('setLoading', params)
  },
  // 根据tab更新CityId和areaId属性
  updateCityAndAreaValue({ commit, state, getters }, { cityId = '', countyIds = [], callback }) {
    commit('updateSearchNot', false)
    updateCityAndAreaValue({ commit, state, getters }, { cityId, countyIds, callback })
    requestListData({ commit, state, getters }, { callback, reset: true })
  },
  // 重置筛选项：只重置最左侧的筛选项
  resetInteractionFilterValues({ commit, state, getters }) {
    const keys = exceptFilterKey[state.currentTab]
    const defaultValues = { ...defaultInteractionFilterValues }
    keys.forEach(item => {
      delete defaultValues[item]
    })
    commit('updateSearchNot', false)
    // 只重置最左侧的筛选集合，所以把其他筛选的重置去掉
    delete defaultValues.sortType
    commit('updateFilterValues', defaultValues)
    requestListData({ commit, state, getters }, { reset: true })
  },
  // 设置额外的tips筛选项
  setOtherPageArrStrategyTagId({ commit }, params) {
    commit('setOtherPageArrStrategyTagId', params)
  },
  // 首页跳转过来展示和设置标签的action
  selectCityAndTagId({ commit, state, getters }, { cityId = '', tagIds = [], currentTab }) {
    const indexTagIds = tagIds.map(num => num.toString())
    const arrTags = state.filterOptions.arrTag || []
    const hasTagIds = arrTags
      .filter(item => indexTagIds.includes(item.value.toString()))
      .map(item => item.value.toString())
    commit('updateSearchNot', false)
    commit('setOtherPageArrStrategyTagId', tagIds)
    commit('updateCurrentTab', currentTab)
    const params = {
      arrTag: hasTagIds,
    }
    // 只需要取
    const { cityIds = [] } = state.filterOptions || {}
    const currentCity = cityIds.find(item => item.id === cityId) || {}
    const { children = [] } = currentCity || {}

    const countyIds = (children || []).reduce((arg = [], item = {}) => {
      return arg.concat((item.children || []).map(item => item.id))
    }, [])
    if (cityId) {
      params.cityId = cityId
      params.countyIds = countyIds
    }
    commit('updateFilterValues', params)
    updateAllTabBycityChange({ commit, state, getters })
    requestListData({ commit, state, getters }, { reset: true })
  },
  getStatusNum({ commit, state }, params) {
    fetchBizoppTitle(params).then(res => {
      // 这里拿到签约状态的数值
      commit('updateCountByStatus', res.data)
      return res.data
    })
  },
  getShopContactInfo({ commit, state }, params) {
    return fetchShopContactInfo(params).then(res => {
      commit('updatePhoneInfo', res.data)
      return res.data
    })
  },
  async updatePriceData({ commit, state }, params) {
    const { year, week, start_date, end_date, ...query } = params
    /** 更新油品类型 */
    commit('updateProductParams', params)
    /** 实时卡片loading */
    commit('updatePriceLoading', true)
    /** 零售价卡片loading */
    commit('updatePumpLoading', true)
    /** 实时趋势图表loading */
    commit('updatePriceChartLoading', true)
    getPriceData({
      ...query,
      start_date,
      end_date,
    }).then(res => {
      commit('updateRealTimeData', res.data)
    })
    getMarketPrice({
      ...query,
      year,
      week,
    }).then(res => {
      commit('updateMarketPriceData', res)
    })
    getHistoryPrice({
      ...query,
      start_date,
      end_date,
    }).then(res => {
      commit('updateHistoryPrice', res)
    })
  },
  async updateMarketPrice({ commit, state }, params) {
    /** 更新油品类型 */
    commit('updateProductParams', params)
    /** 零售价卡片loading */
    commit('updatePumpLoading', true)
    getMarketPrice(params).then(res => {
      commit('updateMarketPriceData', res)
    })
  },
  async updatePriceTrend({ commit, state }, params) {
    /** 更新油品类型 */
    commit('updateProductParams', params)
    /** 实时趋势图表loading */
    commit('updatePriceChartLoading', true)
    await getHistoryPrice(params).then(res => {
      commit('updateHistoryPrice', res)
    })
  },
  async updateOperationData({ commit, state }, params) {
    /** 经营卡片loading */
    commit('updateOperationLoading', true)
    await getOperationData(params).then(res => {
      commit('updateOperationData', res.data)
    })
  },
}
